import { inputRestrictions, inputSanitizers } from './constants.js';

function useRestrictChars(type) {
    function restrictBeforeInput(event) {
        if (inputRestrictions[type] &&
            event.data &&
            !event.data.match(inputRestrictions[type])) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
    }
    function sanitizeInput(value) {
        if (inputRestrictions[type]) {
            return value.replace(inputSanitizers[type], '');
        }
        return value;
    }
    return {
        restrictBeforeInput: restrictBeforeInput,
        sanitizeInput: sanitizeInput,
    };
}

export { useRestrictChars };
